import ko from 'knockout';
import { frameOrigin } from '@/platform/composables/useLightspeedBridge';

export const isInLightspeed = ko.observable(false);
export const lightspeedState = ko.observable({
  isQuickAddOpen: false,
  parentHref: '',
  isDarkEnabled: false,
});
export const lightspeedProjectChannelId = ko.observable(null);
export const isEmbeddedChatEnabled = ko.observable(false);

// Toast callback management - shared with useLightspeedBridge
const toastCallbacks = new Map();

// Track pending toast references awaiting IDs from Lightspeed
export const pendingToastReferences = new Map();

export function registerToastCallback(callbackName, callback) {
  toastCallbacks.set(callbackName, callback);
}

export function handleToastCallback(callbackName) {
  const callback = toastCallbacks.get(callbackName);
  if (!callback) {
    console.warn(`[Toast] Callback "${callbackName}" not found`);
    return false;
  }
  try {
    callback();
    return true;
  } catch (e) {
    console.error('[Toast] Callback error:', e);
    return false;
  } finally {
    toastCallbacks.delete(callbackName);
  }
}

export function handleToastCreated({ callbackId, toastId }) {
  const toastRef = pendingToastReferences.get(callbackId);
  if (toastRef) {
    toastRef.id = toastId;
    pendingToastReferences.delete(callbackId);
  }
}

export function deleteToastCallback(callbackName) {
  toastCallbacks.delete(callbackName);
}

export function postMessageToLightspeed(name, opts) {
  window.parent.postMessage({ name, ...opts }, frameOrigin);
}

export function redirectTo(url) {
  postMessageToLightspeed('twa:redirect', { url });
}

export function report401() {
  postMessageToLightspeed('twa:report-401');
}

export function showToastInLightspeed(toastOptions) {
  postMessageToLightspeed('twa:toast-open', toastOptions);
}

export function openTaskEditDialog(taskId) {
  postMessageToLightspeed('twa:open-dialog', {
    dialogName: 'TaskEditDialog',
    dialogProps: { taskId: Number(taskId) },
  });
}
